import React, { FC, useContext } from 'react';
import styled from 'styled-components';
import { Text } from 'src/components/text/Text';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import { ContentWrapper } from 'components/content-wrapper/ContentWrapper';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { SubscriptionCard } from './SubscriptionCard';
import { CmsContext } from 'logic/context/cms';

const Cards = styled.div<any>`
  display: flex;
  flex-direction: ${({ minTablet }) => (minTablet ? 'row' : 'column')};
`;

export const ScreenShootSection: FC = () => {
  const { minTablet } = useBreakpoints();
  const cms = useContext(CmsContext);
  const { priceFirst, priceSecond, priceLast } = cms;

  const tiers = [
    {
      idx: 1,
      price: priceFirst,
      subscriptionString: 'eur',
      subscriptionInterval: 'month',
      upTo: 1,
    },
    {
      idx: 2,
      price: priceSecond,
      subscriptionString: 'eur',
      subscriptionInterval: 'month',
      upTo: 10,
    },
    {
      idx: 3,
      price: priceLast,
      subscriptionString: 'eur',
      subscriptionInterval: 'month',
      upTo: 10,
    },
  ];

  return (
    <ContentWrapper
      backgroundColor="white"
      style={{ flexDirection: 'column' }}
      padding={minTablet ? '60px 0 120px 0' : '32px 0 64px 0'}
    >
      <Text
        color="blueGray"
        fontWeight={600}
        size={minTablet ? 38 : 26}
        textAlign="center"
        style={{ marginBottom: minTablet ? 70 : 48 }}
      >
        {translate(translationKeys.aboutus.tiersTitle)}
      </Text>
      <Cards minTablet={minTablet}>
        {tiers?.map((tier, idx) => (
          <SubscriptionCard {...tier} key={idx} />
        ))}
      </Cards>
      <Text
        color="black"
        size={minTablet ? 16 : 14}
        textAlign={minTablet ? 'center' : 'left'}
        style={{ marginTop: minTablet ? 34 : 48, marginBottom: minTablet ? 12 : 10 }}
      >
        <strong>{translate(translationKeys.aboutus.tiersSubTitle)}</strong>
        {translate(translationKeys.aboutus.tiersSubTitleContent)}
      </Text>
      <Text color="black" size={minTablet ? 16 : 14} textAlign={minTablet ? 'center' : 'left'}>
        <strong>{translate(translationKeys.aboutus.tiersSubTitle2)}</strong>
        {translate(translationKeys.aboutus.tiersSubTitle2Content)}
      </Text>
    </ContentWrapper>
  );
};
